class CertifiteManager extends HTMLElement {
  constructor() {
    super();
    
    this.inputField = this.querySelector('#ReportNumber');
    this.submitBtn = this.querySelector('[data-submit-btn]');
    this.errorMsgEle = this.querySelector('[data-error-msg]');

    this.formSecEle = document.querySelectorAll('[data-certificate-form],.section-header-banner-text');
    this.resulteSecEle = this.querySelector('[data-certificate-report]');
    this.downloadPDFEle = this.querySelector('[data-download-certificate]');


    // report elements
    this.selectors = {
      previewImage: this.querySelector('[data-preview_image'),
      reportNumber: this.querySelectorAll('[data-report-number]'),
      date: this.querySelector('[data-report-date]'),
      larry: this.querySelector('[data-larry]'),
      description: this.querySelector('[data-description]'),
      shapeCut: this.querySelector('[data-shape-cut]'),
      caratWeight: this.querySelector('[data-carat-weight]'),
      colorGrid: this.querySelector('[data-color-grade]'),
      clarityGrade: this.querySelector('[data-clarity-grade]'),
      polish: this.querySelector('[data-polish]'),
      symmetry: this.querySelector('[data-symmetry]'),
      measurements: this.querySelector('[data-measurements]'),
      tableSize: this.querySelector('[data-table-size]'),
      crownHeight: this.querySelector('[data-crown-height]'),
      pavilionDepth: this.querySelector('[data-pavilion-depth]'),
      girdleThickness: this.querySelector('[data-girdle-thickness]'),
      culet: this.querySelector('[data-culet]'),
      totalDepth: this.querySelector('[data-total-depth]'),
      fluorescence: this.querySelector('[data-fluorescence]'),
      comments: this.querySelector('[data-comments]'),
      inscription: this.querySelector('[data-inscription]'),
      product: this.querySelector('[data-product]'),
      frontShap: this.querySelector('[data-front-shape]'),
      fontStoneType: this.querySelector('[data-front-stone-type]'),
      metal: this.querySelector('[data-metal]'),
      weight: this.querySelector('[data-weight]')
    }
    
    this.init();
  }
  
  onsubmit = () => {
    this.submitBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      let _this = e.currentTarget;
      if(this.inputField.value != '') {
        _this.classList.add('disabled');
        const response = await fetch(`https://certificate-manager.diamondrensu.com/api/certificate/get/${this.inputField.value}`, { method: 'GET' });
        if (response.status == 200) {
          this.inputField.classList.remove('border-danger');
          let data = await response.json();
          let image_url = await fetch(`https://certificate-manager.diamondrensu.com/api/certificate/preview?certificate_number=${this.inputField.value}`, { method: 'GET' });
          image_url = await image_url.json();
          this.renderData(data,image_url.preview);
        } else if(response.status == 422) {
          let errorMsg = await response.json();
          this.errorMsgEle.innerHTML = errorMsg.message;
          setTimeout(() => {
            this.errorMsgEle.innerHTML = ''  
          }, 3000);
        } else {
          this.errorMsgEle.innerHTML = 'Something went wrong, please try again.'
          setTimeout(() => {
            this.errorMsgEle.innerHTML = ''  
          }, 3000);
        }
        _this.classList.remove('disabled');
      } else {
        this.inputField.classList.add('border-danger');
      }
    })  
  }
  
  renderData = (data,image_url) => {
    let response = data.certificate;
    if (image_url) {
      this.selectors.previewImage.src = image_url;
      this.downloadPDFEle.href = `https://certificate-manager.diamondrensu.com/api/certificate/download?certificate_number=${this.inputField.value}`;
    }
    this.selectors.reportNumber.forEach(report => {
      report.innerHTML = response.certificate_number;;
    });
    if(response.shape || response.cut) {
      this.selectors.shapeCut.innerHTML = `${response.shape} ${response.cut}`;
      this.selectors.shapeCut.closest('tr').classList.remove('d-none');
    } else {
      this.selectors.shapeCut.closest('tr').classList.add('d-none');
    }
    if(response.date) {
      this.selectors.date.closest('tr').classList.remove('d-none');
      this.selectors.date.innerHTML = response.date;
    } else {
      this.selectors.date.closest('tr').classList.add('d-none');
    }
    if(response.larry) {
      this.selectors.closest('tr').classList.remove('d-none');
      this.selectors.larry.innerHTML = response.larry;
    } else {
      this.selectors.larry.closest('tr').classList.add('d-none');
    }
    if(response.description) {
      this.selectors.description.closest('tr').classList.remove('d-none');
      this.selectors.description.innerHTML = response.description;
    } else {
      this.selectors.description.closest('tr').classList.add('d-none');
    }
    if(response.carat_weight) {
      this.selectors.caratWeight.closest('tr').classList.remove('d-none');
      this.selectors.caratWeight.innerHTML = response.carat_weight;
    } else {
      this.selectors.caratWeight.closest('tr').classList.add('d-none');
    }
    if(response.color_grade) {
      this.selectors.colorGrid.closest('tr').classList.remove('d-none');
      this.selectors.colorGrid.innerHTML = response.color_grade;
    } else {
      this.selectors.colorGrid.closest('tr').classList.add('d-none');
    }
    if(response.clarity_grade) {
      this.selectors.clarityGrade.closest('tr').classList.remove('d-none');
      this.selectors.clarityGrade.innerHTML = response.clarity_grade;
    } else {
      this.selectors.clarityGrade.closest('tr').classList.add('d-none');
    }
    if(response.polish) {
      this.selectors.polish.closest('tr').classList.remove('d-none');
      this.selectors.polish.innerHTML = response.polish;
    } else {
      this.selectors.polish.closest('tr').classList.add('d-none');
    }
    if(response.symmetry) {
      this.selectors.symmetry.closest('tr').classList.remove('d-none');
      this.selectors.symmetry.innerHTML = response.symmetry;
    } else {
      this.selectors.symmetry.closest('tr').classList.add('d-none');
    }
    if(response.measurements) {
      this.selectors.measurements.closest('tr').classList.remove('d-none');
      this.selectors.measurements.innerHTML = response.measurements;
    } else {
      this.selectors.measurements.closest('tr').classList.add('d-none');
    }
    if(response.table_size) {
      this.selectors.tableSize.closest('tr').classList.remove('d-none');
      this.selectors.tableSize.innerHTML = response.table_size;
    } else {
      this.selectors.tableSize.closest('tr').classList.add('d-none');
    }
    if(response.crown_height) {
      this.selectors.crownHeight.closest('tr').classList.remove('d-none');
      this.selectors.crownHeight.innerHTML = response.crown_height;
    } else {
      this.selectors.crownHeight.closest('tr').classList.add('d-none');
    }
    if(response.pavilion_depth) {
      this.selectors.pavilionDepth.closest('tr').classList.remove('d-none');
      this.selectors.pavilionDepth.innerHTML = response.pavilion_depth;
    } else {
      this.selectors.pavilionDepth.closest('tr').classList.add('d-none');
    }
    if(response.girdle_thickness) {
      this.selectors.girdleThickness.closest('tr').classList.remove('d-none');
      this.selectors.girdleThickness.innerHTML = response.girdle_thickness;
    } else {
      this.selectors.girdleThickness.closest('tr').classList.add('d-none');
    }
    if(response.culet) {
      this.selectors.culet.closest('tr').classList.remove('d-none');
      this.selectors.culet.innerHTML = response.culet;
    } else {
      this.selectors.culet.closest('tr').classList.add('d-none');
    }
    if(response.total_depth) {
      this.selectors.totalDepth.closest('tr').classList.remove('d-none');
      this.selectors.totalDepth.innerHTML = response.total_depth;
    } else {
      this.selectors.totalDepth.closest('tr').classList.add('d-none');
    }
    if(response.fluorescence) {
      this.selectors.fluorescence.closest('tr').classList.remove('d-none');
      this.selectors.fluorescence.innerHTML = response.fluorescence;
    } else {
      this.selectors.fluorescence.closest('tr').classList.add('d-none');
    }
    if(response.comments) {
      this.selectors.comments.closest('tr').classList.remove('d-none');
      this.selectors.comments.innerHTML = response.comments;
    } else {
      this.selectors.comments.closest('tr').classList.add('d-none');
    }
    if(response.inscriptions) {
      this.selectors.inscription.closest('tr').classList.remove('d-none');
      this.selectors.inscription.innerHTML = response.inscriptions;
    } else {
      this.selectors.inscription.closest('tr').classList.add('d-none');
    }

    if(response.weight) {
      this.selectors.weight.closest('tr').classList.remove('d-none');
      this.selectors.weight.innerHTML = response.weight;
    } else {
      this.selectors.weight.closest('tr').classList.add('d-none');
    }
    if(response.metal) {
      this.selectors.metal.closest('tr').classList.remove('d-none');
      this.selectors.metal.innerHTML = response.metal;
    } else {
      this.selectors.inscription.closest('tr').classList.add('d-none');
    }
    if(response.front_stone_type) {
      this.selectors.fontStoneType.closest('tr').classList.remove('d-none');
      this.selectors.fontStoneType.innerHTML = response.front_stone_type;
    } else {
      this.selectors.fontStoneType.closest('tr').classList.add('d-none');
    }
    if(response.front_shape) {
      this.selectors.frontShap.closest('tr').classList.remove('d-none');
      this.selectors.frontShap.innerHTML = response.front_shape;
    } else {
      this.selectors.frontShap.closest('tr').classList.add('d-none');
    }
    if(response.product) {
      this.selectors.product.closest('tr').classList.remove('d-none');
      this.selectors.product.innerHTML = response.product;
    } else {
      this.selectors.product.closest('tr').classList.add('d-none');
    }

    this.formSecEle.forEach(formEle => formEle.classList.add('d-none'));
    this.resulteSecEle.classList.remove('d-none');
  }
  
  init = () => {
    this.onsubmit();
  }
}
customElements.define('certificate-manager', CertifiteManager)